import { createEvent, createStore } from 'effector';
import { CurrentOrganization } from './types';

export const loadOrganization = createEvent<CurrentOrganization | null>();
export const $currentOrganization = createStore<CurrentOrganization | null>(
  null
);
